import React from 'react'
import useAssignLoads from 'tennders-market/load/hooks/useAssignLoads'
import GLoading from 'tennders-market/common/components/element/GLoading'
import useTranslation from 'next-translate/useTranslation'
import DistanceFilter from './DistanceFilter'
import AssignTransactions from './AssignTransactions'

const AssignLoads = () => {
  const {
    loading,
    loads,
    setrange,
    range,
    dateRange,
    setdateRange
  } = useAssignLoads()
  const { t } = useTranslation()

  return (
    <div className="bg-color-white p-10 mt-10">
      <div className="tennders-brokers-trucks-match-load-info">
        <div className="d-flex justify-space align-center mb-20">
          <h3 className="bold mb-0 mr-10">{t('transaction:loadsReadyToAssign')}</h3>
          <DistanceFilter
            dateRange={dateRange}
            setdateRange={setdateRange}
            setrange={setrange}
            range={range}
          />
        </div>
        {loading ? <GLoading /> : <AssignTransactions transactions={loads} /> }
      </div>
    </div>
  )
}

export default AssignLoads
